
import { TorontoHero } from './components/TorontoHero';
import { TorontoOverview } from './components/TorontoOverview';
import { TorontoLicensing } from './components/TorontoLicensing';
import { TorontoEnforcement } from './components/TorontoEnforcement';
import { TorontoMarket } from './components/TorontoMarket';
import { TorontoCTA } from './components/TorontoCTA';
import { Navbar } from '../home/components/Navbar';
import { Footer } from '../home/components/Footer';

export default function TorontoSTR() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <TorontoHero />
        <TorontoOverview />
        <TorontoLicensing />
        <TorontoEnforcement />
        <TorontoMarket />
        <TorontoCTA />
      </main>
      <Footer />
    </div>
  );
}
